import React, { Component } from 'react'

export default class service extends Component {
    render() {
        return (
          
<svg  className={this.props.className} onClick={this.props.onClick} width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.31732 2.57659C8.23752 2.37938 8.38267 2.16406 8.59542 2.16406H15.6754C15.8882 2.16406 16.0333 2.37938 15.9535 2.57659L14.4949 6.18122C14.449 6.29453 14.339 6.36869 14.2168 6.36869H10.0541C9.93182 6.36869 9.82181 6.29453 9.77596 6.18122L8.31732 2.57659Z" stroke="#001F82" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round"/>
<path d="M9.80219 6.60925C9.82988 6.4686 9.95321 6.36719 10.0966 6.36721L14.1695 6.3675C14.3129 6.36751 14.4362 6.46892 14.4638 6.60956L16.933 19.1543C16.9547 19.2645 16.913 19.3777 16.8249 19.4474L12.3188 23.0146C12.2097 23.101 12.0555 23.101 11.9464 23.0146L7.44037 19.4474C7.35226 19.3777 7.31052 19.2645 7.33223 19.1542L9.80219 6.60925Z" stroke="#001F82" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round"/>
</svg>
        )
    }
}
